import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "@/lib/motion";
import { CASE_STUDIES } from "@/data";

export default function CaseStudies() {
  return (
    <section id="case-studies" data-testid="case-studies-section" className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <Eyebrow>Selected work</Eyebrow>
          <h2 className="mt-5 font-display font-normal text-4xl md:text-5xl lg:text-6xl tracking-tight">
            Quiet results, real businesses.
          </h2>
        </div>
        <a href="#book" data-testid="cases-start-project" className="font-mono text-xs uppercase tracking-[0.15em] text-brand-teal border-b border-brand-teal pb-1 hover:text-brand-ink transition-colors">
          Start your project
        </a>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
        {CASE_STUDIES.map((c, i) => (
          <Reveal key={c.client} delay={i * 0.1}>
            <motion.a
              href="#book"
              whileHover="hover"
              className="group block"
              data-testid={`case-study-${i}`}
            >
              <div className="relative overflow-hidden rounded-3xl border border-brand-sage">
                <motion.img
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  src={c.img}
                  alt={c.client}
                  className="w-full h-[46vh] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/60 via-transparent to-transparent" />
                <span className="absolute top-5 left-5 font-mono text-[10px] uppercase tracking-[0.2em] text-brand-ink bg-brand-cream px-3 py-1.5 rounded-full">
                  {c.tag}
                </span>
                <div className="absolute bottom-5 left-5 right-5">
                  <div className="font-display text-3xl md:text-4xl text-brand-cream">{c.result}</div>
                </div>
              </div>
              <div className="mt-6 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl">{c.client}</h3>
                  <p className="text-brand-ink/70 mt-2 max-w-md leading-relaxed">{c.desc}</p>
                </div>
              </div>
            </motion.a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
